import React from 'react'

import { Stack } from '@mui/material'
import { useSelector } from 'react-redux'

import type { RootState } from 'reduxStore'

const styles = {
  root: {
    height: '90%'
  },
  details: {
    height: '100%',
    overflowY: 'auto',
    padding: '10px'
  },
  logo: {
    maxWidth: '300px',
    maxHeight: '70px'
  }
}

const AboutPanelSiteDetails: React.FC = () => {
  const enabled = useSelector((state: RootState) =>
    state.config?.layout?.drawer?.tabs?.about?.panels?.details?.enabled ?? true
  )
  const mapIcon = useSelector((state: RootState) => state.config?.layout?.mapicon ?? '')
  const bigLogo = useSelector((state: RootState) => state.config?.layout?.biglogo ?? '')
  const blurbHtml = useSelector((state: RootState) => state.config?.layout?.drawer?.tabs?.about?.html ?? '')

  const siteLogo = mapIcon || bigLogo

  if (!enabled) {
    return null
  }

  if (!siteLogo && !blurbHtml) {
    return null
  }

  const Logo = (siteLogo &&
    <Stack alignItems="center">
      <img src={siteLogo} alt="site logo" style={styles.logo} />
    </Stack>
  )

  return (
    <Stack direction="column" spacing={1} sx={styles.root}>
      <Stack sx={styles.details}>
        {Logo}
        {blurbHtml && <Stack dangerouslySetInnerHTML={{ __html: blurbHtml }} />}
      </Stack>
    </Stack>
  )
}

export default AboutPanelSiteDetails
